import { Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import ProfilLargeIcon from "@static/icons/ProfilLarge.svg";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { useLoginLogout } from "@hooks/useLoginLogout";
import { useStyle } from "./style";

interface IParams {
    email?: string;
    onUseDifferentEmail(): void;
}

export const UserAlreadyExists = (props: IParams) => {
    const { email, onUseDifferentEmail } = props;
    const { t } = useTranslation("customerDetails");
    const { logIn } = useLoginLogout();
    const { classes } = useStyle();

    return (
        <Stack alignItems="center" className={classes.container} spacing={2} width="100%">
            <ProfilLargeIcon className={classes.icon} />
            <Stack alignItems="center" spacing={1.5}>
                <Typography align="center" variant="h2">
                    {t("userAlreadyExists.title")}
                </Typography>
                <Stack alignItems="center" spacing={3}>
                    <Stack alignItems="center" spacing={0}>
                        <Typography align="center" color="secondary" variant="normal">
                            <Trans
                                components={{
                                    email: <Typography className={classes.email} component="span" />,
                                }}
                                i18nKey="userAlreadyExists.subtitle"
                                ns="customerDetails"
                                values={{ email }}
                            />
                        </Typography>
                        <Typography align="center" color="secondary" variant="normal">
                            {t("userAlreadyExists.subtitle2")}
                        </Typography>
                    </Stack>
                    <Stack alignItems="center" spacing={2}>
                        <LabeledButton
                            color="primary"
                            labelText={t("userAlreadyExists.loginCta")}
                            onClick={() => logIn()}
                        >
                            {t("userAlreadyExists.loginCta")}
                        </LabeledButton>
                        <LabeledButton
                            color="primary"
                            labelText={t("userAlreadyExists.useDifferentEmailCta")}
                            variant="text"
                            onClick={onUseDifferentEmail}
                        >
                            {t("userAlreadyExists.useDifferentEmailCta")}
                        </LabeledButton>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
};
